/*
 *
 * ProcessingRulesForm
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 17-Jan-2025
 */

import { connect } from 'react-redux'
import ProcessingRulesForm from './ProcessingRulesForm'

import { bindActionCreators } from 'redux'
import * as actionLayer from 'Route/TerminalsManagement/modules/TerminalsManagementActions'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(dispatch),
  resetSelectedRule: () => dispatch(actionLayer.doSetSelectedRule(null))
})

const mapStateToProps = (state) => ({
  selectedRule: state?.TerminalsManagement?.selectedRule || null,
  action: state.popup?.popupData || ''
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ProcessingRulesForm)
